module.exports = __webpack_public_path__ + "3070bcbbbbcdcebb86746a6e6147d15f.MP3";